import { FluidOutputReportResponse } from "../../../services/api/types/forms/responses/FluidOutputReportResponse";
import { useMemo } from "react";
import { getFullName } from "ui/utils/nameUtil";
import {
  AccordionContent,
  AccordionHeader,
  AccordionIcon,
  AccordionItem,
  AccordionTitleText,
  AccordionTrigger,
} from "ui/gluestack/accordion";
import { Text, View } from "react-native";
import { format } from "date-fns";
import { ChevronDownIcon, ChevronUpIcon } from "ui/gluestack/icon";
import KeyValueGrid from "ui/organisms/KeyValueGrid";

interface Props {
  log: FluidOutputReportResponse;
}
export function FluidOutputHistoryItem({ log }: Props) {
  const createdBy = useMemo(() => {
    return getFullName(log.user);
  }, [log?.user]);

  const fluidOutputLogs = useMemo(
    () => [
      {
        label: "Fluid Output",
        value: `${log.output_volume} ml`,
      },
      {
        label: "Output Type",
        value: log.output_type,
      },
      {
        label: "Note",
        value: log.output_type_description ?? "N/A",
      },
      { label: "Recorded By", value: createdBy ?? "N/A" },
    ],
    [log],
  );

  return (
    <AccordionItem
      key={log.id}
      value={`${log.id}`}
      className="border rounded-lg border-border-200 p-2"
    >
      <AccordionHeader>
        <AccordionTrigger className="focus:web:rounded-lg">
          {({ isExpanded }) => (
            <>
              <AccordionTitleText className="mr-1">
                <Text className="capitalize">{log.output_type}</Text>
                <Text className="text-xs font-medium text-typography-600">
                  {format(new Date(log.created_at), " - dd-MM-yyyy 'at' HH:mm")}
                </Text>
              </AccordionTitleText>

              {isExpanded ? (
                <AccordionIcon as={ChevronUpIcon} />
              ) : (
                <AccordionIcon as={ChevronDownIcon} />
              )}
            </>
          )}
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent>
        <View>
          <KeyValueGrid items={fluidOutputLogs} />
        </View>
      </AccordionContent>
    </AccordionItem>
  );
}
